module.exports = __webpack_public_path__ + "img/affc0bd.png";